import { useMemo } from 'react';

import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';
import { useAuth } from '@verantos-dev/core-auth';
import { SIDEBAR_APPS } from '@verantos-dev/core-constants';
import { EvidencePlatformSidebarAppID, UserRolesIdsEnum } from '@verantos-dev/core-enums';

export const useAllowedApps = () => {
  const {
    user: { roles, isInternalUser },
  } = useAuth();
  const isAvLibraryEnabled = useFeatureFlagSplit('research_assistant_gen_3');
  // TODO: cleanup with data_reliability ff
  const isDataReliabilityPageEnabled = useFeatureFlagSplit('data_reliability');
  // TODO: cleanup with research_assistant_developer_tools ff — OR-6432 Block B.
  // Internal-only, project-independent RA session review tool: never shown to
  // a customer regardless of flag state. This is a UX-only gate — every
  // backend call on that page re-checks is_internal + the flag independently.
  // Hook called unconditionally (rules of hooks); isInternalUser is ANDed in
  // after the call, not used to gate whether the hook runs.
  const isRaDeveloperToolsFlagEnabled = useFeatureFlagSplit('research_assistant_developer_tools');
  const isRaSessionReviewEnabled = isInternalUser && isRaDeveloperToolsFlagEnabled;
  const sidebarAppIds = roles.reduce((_apps, _role) => {
    switch (_role.roleId) {
      case UserRolesIdsEnum.OR_RESEARCHER:
        return [
          EvidencePlatformSidebarAppID.projects,
          EvidencePlatformSidebarAppID.conceptGroups,
          ...(isAvLibraryEnabled ? [EvidencePlatformSidebarAppID.analyticalVariables] : []),
          // TODO: cleanup with data_reliability ff
          ...(isDataReliabilityPageEnabled ? [EvidencePlatformSidebarAppID.dataReliability] : []),
          // TODO: cleanup with research_assistant_developer_tools ff
          ...(isRaSessionReviewEnabled ? [EvidencePlatformSidebarAppID.raSessionReview] : []),
          ..._apps,
        ];
      case UserRolesIdsEnum.SA_ADMIN:
        return [
          EvidencePlatformSidebarAppID.users,
          ...(isInternalUser ? [EvidencePlatformSidebarAppID.organizations] : []),
          ..._apps,
        ];
      default:
        return _apps;
    }
  }, [] as EvidencePlatformSidebarAppID[]);

  return useMemo(() => {
    return SIDEBAR_APPS.filter((app) => sidebarAppIds.includes(app.appId)).map((app) => {
      if (app.appId === EvidencePlatformSidebarAppID.users && !isInternalUser) {
        return {
          ...app,
          additionalItems: [],
        };
      }

      return {
        ...app,
      };
    });
  }, [sidebarAppIds, isInternalUser]);
};
